<script lang="ts">
    export let size: number;
    export let color: string = "#000000";
</script>

<!--https://dev.materialdesignicons.com/icon/layers-off-->
<svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        version="1.1"
        width={size}
        height={size}
        viewBox="0 0 {size} {size}">
    <path
            fill={color}
            d="M3.27,1L2,2.27L6.22,6.5L3,9L4.63,10.27L12,16L14.1,14.37L15.53,15.8L12,18.54L4.63,12.81L3,14.07L12,21.07L16.95,17.22L20.73,21L22,19.73L3.27,1M19.36,10.27L21,9L12,2L9.09,4.27L16.96,12.15L19.36,10.27M19.81,15L21,14.07L19.57,12.64L18.38,13.56L19.81,15Z"/>
</svg>
